import React, { useState, useEffect } from 'react';
import { FaShoppingCart, FaCreditCard, FaGlobe, FaBullhorn, FaRocket, FaStore } from 'react-icons/fa';
import LoadingSpinner from '../Orders/LoadingSpinner';

// Controller Components
import DealOfTheWeek from '../Controller/DealOfTheWeek';
import StorefrontStudio from '../Controller/StorefrontStudio';
import PaymentGatewaySettings from '../Controller/PaymentGatewaySettings';
import CampaignPages from '../Controller/CampaignPages';

import './MyWebsites.css';

const MyWebsites = () => {
  const loading = false;
  const [activeTab, setActiveTab] = useState(() => {
    const saved = localStorage.getItem('activeTab');
    return ['content', 'settings', 'analytics', 'orders'].includes(saved) ? 'studio' : saved || 'studio';
  });

  useEffect(() => {
    localStorage.setItem('websiteType', 'custom');
  }, []);

  // Persist activeTab to localStorage
  useEffect(() => {
    if (['content', 'settings', 'analytics', 'orders'].includes(activeTab)) {
      setActiveTab('studio');
      return;
    }
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const renderTabs = () => {
    return (
      <div className="website-tabs">
        <button
          className={`tab-btn ${activeTab === 'campaigns' ? 'active' : ''}`}
          onClick={() => setActiveTab('campaigns')}
        >
          <FaBullhorn /> Campaign Pages
        </button>
        <button
          className={`tab-btn ${activeTab === 'payments' ? 'active' : ''}`}
          onClick={() => setActiveTab('payments')}
        >
          <FaCreditCard /> Payment Gateway
        </button>
        <button
          className={`tab-btn ${activeTab === 'studio' ? 'active' : ''}`}
          onClick={() => setActiveTab('studio')}
        >
          <FaStore /> Storefront Studio
        </button>
        <button
          className={`tab-btn ${activeTab === 'deals' ? 'active' : ''}`}
          onClick={() => setActiveTab('deals')}
        >
          <FaShoppingCart /> Deals
        </button>
      </div>
    );
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'studio':
        return <StorefrontStudio />;
      case 'deals':
        return <DealOfTheWeek />;
      case 'payments':
        return <PaymentGatewaySettings />;
      case 'campaigns':
        return <CampaignPages />;
      default:
        return <StorefrontStudio />;
    }
  };

  if (loading) {
    return (
      <div className="responsive-box">
        <div className="loading-container">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="responsive-box">
      <div className="my-websites-container">
        <div className="websites-hero">
          <div>
            <span className="websites-kicker"><FaRocket /> Website Operations</span>
            <h2>My Websites</h2>
            <p>Manage your custom PaisaVara storefront, campaign pages, payment setup, deals and website content from one focused workspace.</p>
          </div>
        </div>

        <div className="website-context-card">
          <div>
            <span className="websites-kicker subtle"><FaGlobe /> Active Workspace</span>
            <h3>Custom Storefront</h3>
            <p>Everything shown here is scoped to your store and the custom ecommerce website configured for it.</p>
          </div>
          <div className="website-context-icon">
            <FaStore />
          </div>
        </div>

        {renderTabs()}

        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default MyWebsites;
